import { AsyncComponentRender } from '@components/AsyncComponent';
import { createTabs } from '@packages/tabs';

export const ADMIN_TABS = createTabs([
    ['profile', 'Profile', AsyncComponentRender(() => import('./Profile'))],
    ['security', 'Security', AsyncComponentRender(() => import('./Security'))],
]);

export const SALESMAN_TABS = createTabs([
    ['profile', 'Profile', AsyncComponentRender(() => import('./Profile'))],
    ['referral', 'Refer', AsyncComponentRender(() => import('./Refer'))],
    ['security', 'Security', AsyncComponentRender(() => import('./Security'))],
]);

export const WHOLESALER_TABS = createTabs([
    ['security', 'Security', AsyncComponentRender(() => import('./Security'))],
]);
